import evaApi from './apiEvaluation'

export default {
  syncEvaluationRecord: (params?: any) => {
    return evaApi.get('/wx/app/evaluation/feedback', params)
  },
};
